/**
 * * Получить base64 из файла
 * @param file Файл
 * @returns
 */
export const getBase64FromFile = (file: File): Promise<string | undefined> => {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = reader.result;
      if (result) {
        resolve(result.toString());
      } else {
        resolve(undefined); // В случае ошибки чтения
      }
    };

    reader.onerror = () => {
      resolve(undefined); // В случае ошибки
    };

    reader.readAsDataURL(file); // Читаем файл как Data URL
  });
};
